import styled from '@emotion/styled';
import rem from '../../../utils/rem/rem';

export const ExtractCouponGroupsPage = styled.div`
  padding: 0 32px;
  display: flex;
  height: calc(100vh - 208px);
`;

export const TableRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-grow: 1;
  margin-bottom: ${rem(16)};
  gap: ${rem(16)} 32px;
  padding-top: ${rem(16)};

  @media ${({ theme }) => theme.breakpoints.lg} {
    flex-direction: column;
  }
`;

export const TableWrapper = styled.div`
  width: calc(50vw - 232px);
  min-width: ${rem(396)};

  @media ${({ theme }) => theme.breakpoints.lg} {
    width: 100%;
  }
`;

export const Buttons = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.gray400};
  padding-left: 32px;
  margin-left: 32px;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${rem(16)} 24px;
  margin-bottom: ${rem(16)};
`;

export const InputWrapperMedium = styled.div`
  width: ${rem(190)};
`;

export const ColumnWrapper= styled.div`
display: flex;
flex-direction: column;
`;

export const DateHelperText = styled.div`
  font-family: 'Open Sans';
  font-size: ${rem(11)};
  padding-top: ${rem(4)};
  color: ${({ theme }) => theme.colors.gray600};
`;
